import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';

@Component({
    selector: 'page-article-view-others',
    templateUrl: 'article-view-others.html',
})
export class ArticleViewOthersPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {

    }


}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-others/article-view-others.ts